import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

import Colors from '../resource/ResourceColors.jsx';
import {MAIN_APP} from "../MidiPlay";

const MEDIUM_LINE = "0.125rem";
const ITEM_COLOR = Colors.primary(30);
const ITEM_HILIGHT_COLOR = Colors.primary(100);

const DropdownContainer = styled.div`    
    position: absolute;
    min-width: 8rem;
    overflow: auto;
    filter: ${Colors.wide_shadow(30)};
    z-index: 100;
    border: ${MEDIUM_LINE} solid  ${Colors.grey(50)};
    border-radius: 0.25rem;
    background: ${Colors.right_diagonal_gradient_grey(100, 80)};
`;

const DropdownElement = styled.div`
    padding: 0.2rem 0.5rem;
    font-size: 0.95rem;
`;

const DropdownLabel = styled.div`
    color: ${ITEM_COLOR};
    padding: 0.2rem 0.5rem;
    border-radius: 0.25rem;
`;

const DropdownSeparator = styled.div`
    border-bottom: ${MEDIUM_LINE} solid ${Colors.grey(70)}
`;

export class UtilDropdown extends Component {

    static propTypes = {
        location: PropTypes.object.isRequired,
        items: PropTypes.array.isRequired,
        listener: PropTypes.func.isRequired,
        name: PropTypes.string,
    }

    on_click(e) {
        MAIN_APP.setState({dropdown: null});
    }

    componentDidMount() {
        document.addEventListener('click', this.on_click);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.on_click);
    }

    mouse_over_item(e, item_ref, label_ref) {
        const label = label_ref.current;
        if (label) {
            label.style.color = ITEM_HILIGHT_COLOR;
            label.style.background = Colors.right_diagonal_gradient(80, 60);
            label.style.textShadow = Colors.medium_text_shadow(20);
        }
        const item = item_ref.current;
        if (item) {
            item.style.background = Colors.right_diagonal_gradient_grey(100, 90);
        }
    }

    mouse_out_item(e, item_ref, label_ref) {
        const label = label_ref.current;
        if (label) {
            label.style.color = ITEM_COLOR;
            label.style.background = null;
            label.style.textShadow = null;
        }
        const item = item_ref.current;
        if (item) {
            item.style.background = null;
        }
    }

    render() {
        const container_style = {
            left: this.props.location.x + 'px', top: this.props.location.y + 'px'
        };

        const all_items = this.props.items.map((item, key) => {
            const item_ref = React.createRef();
            const label_ref = React.createRef();
            return (item['type'] === 'separator') ?
                <DropdownSeparator key={'dropdown-' + key} ref={item_ref}/> :
                <DropdownElement
                    key={'dropdown-' + key}
                    ref={item_ref}
                    onMouseOut={(e) => this.mouse_out_item(e, item_ref, label_ref)}
                    onMouseOver={(e) => this.mouse_over_item(e, item_ref, label_ref)}
                    onClick={(e) => this.props.listener(item)}>
                    <DropdownLabel ref={label_ref}>{item['label']}</DropdownLabel>
                </DropdownElement>
        });

        return <DropdownContainer
            id={this.props.id}
            style={container_style}>
            {all_items}
        </DropdownContainer>
    }
}

export default UtilDropdown;